import { Component, OnInit, ElementRef, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { IUserDetails } from '../shared/models/UserDetailsOutputModel';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { IBrokerRegionalLicenses } from '../shared/models/BrokerRegionalLicensesInputModel';
import { DataTablesResponse } from '../shared/models/datatables-response';
import { PropertiesAssociatedOutputModel } from '../shared/models/PropertiesAssociatedOutputModel'
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { IPropertySearchCriteria } from '../shared/models/propertysearchcriteria';
import { environment } from '../../environments/environment'
import { CurrencyPipe } from '@angular/common';
import { ValidationService } from '../shared/providers/validation.service';
import { IPropertyAccessInputModel } from '../shared/models/PropertyAccessInputModel';
import { ToastService } from '../shared/providers/toast.service';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UserRole, YesNo } from '../shared/enum/enum';
import { LoaderService } from '../shared/providers/loader.service';
import { PropertyListingService } from '../shared/providers/property-listing.service';
import { DashboardService } from '../shared/providers/dashboard.service';
import { PermissionService } from '../shared/providers/permission.service';
import { Actions, Modules } from '../shared/enum/enum';

enum Tab {
  PersonalInformation = 1,
  ActivityLog = 2,
  InterestCriteria = 3,
  Prospects = 4,
  Associations=5
}

@Component({
  selector: 'principal-details',
  templateUrl: './principal-details.component.html',
  styleUrls: ['./principal-details.component.css']
})
export class PrincipalDetailsComponent implements OnInit {

  protected readonly BASE_URL: string = environment.base_url;

  searchCriteria = {} as IPropertySearchCriteria;
  Modules = Modules;
  Actions = Actions;
  userDetailsOutput = {} as IUserDetails;
  brokerRegionalLicenses: Array<IBrokerRegionalLicenses> = [];
  principalGuid: string = "";
  accessText = "Grant 1031 Access";
  accessModel = {} as IPropertyAccessInputModel;
  dtOptions = {};
  propertiesAssociated: PropertiesAssociatedOutputModel[];
  table: DataTableDirective;
  modalRef: BsModalRef;
  modalRefProspect: BsModalRef;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  yesno = YesNo;
  isViewAuditTrail = false;
  auditObjectId = 0;
  auditObjectTypeId = 0;
  public currentuserid: number = 0;
  viewOrHideLabel = "View";
  prevPage = "External Users";
  prevPageRouteLink = "users/registered-users";
  activeTab = Tab.PersonalInformation;
  hasMyPortfolioAccess: number = 0;
  userRequestedMyPortfolio: boolean = false;
  myPortfolioRequestText: string = '';
  IsPrincipal = false;
  IsBroker = false;
  IsGuest = false;
  prosepctsList = [] as any;
  ModelAccess = {} as any;
  exchangeList = [] as any;
  show1031Exchanges = false;
  showSellerData = false;
  open: boolean = true;
  openProspects: boolean = true;
  openExchange: boolean = true;
  prospectUserId: number = 0;
  constructor(private propertyListing: PropertyListingService, public permissionService: PermissionService, private _dashboardService: DashboardService, private _userManagerService: UserManagerService, private Loader: LoaderService, private activatedRoute: ActivatedRoute, public authService: AuthenticationService, private router: Router, private http: HttpClient, public _validationService: ValidationService, private _toastService: ToastService, private modalService: BsModalService) {

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.principalGuid = params['principal'];
      if (this.userDetailsOutput.ProfilePicPath === undefined || this.userDetailsOutput.ProfilePicPath === null || this.userDetailsOutput.ProfilePicPath.trim().length <= 0) {
        this.userDetailsOutput.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
      }
      if (params['prevPage'] != '' && params['prevPage'] != null && params['prevPage'] != undefined) {
        this.prevPage = params['prevPage'];
      }
      if (params['prevPageRouteLink'] != '' && params['prevPageRouteLink'] != null && params['prevPageRouteLink'] != undefined) {
        this.prevPageRouteLink = params['prevPageRouteLink'];
      }
    });
  }

  User: any;
  ShowbrokerRegionalLicenses = false;
  IsSeller = false;
  ngOnInit() {
    this.Loader.display(true);
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let routeName = params['prevroute'];
      let routeLink = params['link'];
      if (routeName !== null && routeName !== undefined) {
        this.prevPage = routeName;
        this.prevPageRouteLink = routeLink;
        if (this.prevPage == 'Buyer Criteria') {
          this.activeTab = Tab.InterestCriteria;
        }
        if (this.prevPage == '1031 Exchanges') {
          if (params['activeTab'] != null && params['activeTab'] != '' && params['activeTab'] != undefined) {
            let exchangetab = params['activeTab'];
            localStorage.setItem('ExchangeListTab', exchangetab);
          }

        }
      }

      //if (params['property_tab'] !== null && params['property_tab'] !== undefined) {
      //    this.tabToShow = params['property_tab'];
      //}
      //else if (params['tab'] !== null && params['tab'] !== undefined) {
      //    this.tabToShow = params['tab'];
      //}
    });

    this._userManagerService.getUserDetails(this.principalGuid).subscribe(response => {
      this.userDetailsOutput = response;
      this.prospectUserId = this.userDetailsOutput != null && this.userDetailsOutput.ProspectUserId != null && this.userDetailsOutput.ProspectUserId > 0 ? this.userDetailsOutput.ProspectUserId : 0;
      if (this.userDetailsOutput.UserRoleIdList.indexOf(13) > -1) {
        this.IsSeller = true;
        if (this.authService.Admin() || this.authService.SuperAdmin()) {
          this.showSellerData = true;
          this.getProspectsDetails(this.userDetailsOutput.Id);
        }
        this.GetTickersForThisUser();
        this.hasMyPortfolioAccess = 1;
      }
      this.GetPermissionData();
      this.brokerRegionalLicenses = null;
      if (this.userDetailsOutput.UserRoleId != UserRole.Principal && this.userDetailsOutput.UserRoleId != UserRole.Principal1031) {
        if (response.BrokerRegionalLicensesOutputModelList !== null) {
          //Converting  UTC Date into Local Date
          for (let i = 0; i < response.BrokerRegionalLicensesOutputModelList.length; i++) {
            let UTCDate = (response.BrokerRegionalLicensesOutputModelList[i].ExpiryDate);
            var date = new Date(UTCDate + ' UTC');
            response.BrokerRegionalLicensesOutputModelList[i].ExpiryDate_Date = date;
          }
          this.brokerRegionalLicenses = response.BrokerRegionalLicensesOutputModelList;
        }
      }
      else {
        this.brokerRegionalLicenses = null;
      }

      if (this.brokerRegionalLicenses != null) {
        this.ShowbrokerRegionalLicenses = true;
      }

      this.auditObjectId = this.userDetailsOutput.Id;
      this.auditObjectTypeId = 301;

      const user =
      {
        Id: response.Id,
        Name: response.FirstName + " " + response.LastName,
        Role: response.Is1031User ? UserRole.Principal1031 : response.UserRoleId
      }
      this.User = user;
      this.currentuserid = response.Id;
      if (this.userDetailsOutput.ProfilePicPath === undefined || this.userDetailsOutput.ProfilePicPath === null || this.userDetailsOutput.ProfilePicPath.trim().length <= 0) {
        this.userDetailsOutput.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
      }

      this.accessText = this.userDetailsOutput.Is1031EnabledId == YesNo.Yes ? "Reject 1031 Access" : "Grant 1031 Access";

      this.brokerRegionalLicenses = response.BrokerRegionalLicensesOutputModelList;
      this.Loader.display(false);
    });

    this.searchCriteria.Guid = this.principalGuid;

    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
      },
      "pageLength": 50,
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        dataTablesParameters.Extra_param = this.searchCriteria;
        const httpHeader = this._validationService.GetAuthHeader();
        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/property/principalAssociatedPropertyList',
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            that.propertiesAssociated = resp.data ? resp.data : [];
            if (resp.data.length === 0) {
              $(".dataTables_paginate.paging_full_numbers").hide()
            }
            else {
              $(".dataTables_paginate.paging_full_numbers").show()
            }
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            }
            $(".paginate_button.first,.paginate_button.last").hide();
          });
      },
      columns: [{ data: 'PropertyName' },
      { data: 'BrokerName' },
      { data: 'PropertyStatus' },
      { data: 'Price' },
      { data: 'CreditRating' },
      { data: 'CapRate' },
      { data: 'RemainingTerm' },
      { data: 'LeaseStructure' },
      { data: 'BuildingSize' }
      ]
    };
  }

  tickers = [];
  private GetTickersForThisUser() {
    this.propertyListing.GetDefaultTickers(this.userDetailsOutput.Id).subscribe(res => {
      this.tickers = res;
    });
  }

  tab = Tab;

  onTabClick(selectedTab) {
    this.activeTab = selectedTab;
    if (this.activeTab === Tab.PersonalInformation) {
      $(".dataTables_wrapper table thead").show();
    }
  }


  onBreadCrumbClick() {
    this.router.navigateByUrl(this.prevPageRouteLink);
    if (this.prevPage == '1031 Exchanges') {
      let exchangetab = "1";
      if (localStorage.getItem('ExchangeListTab') != null && localStorage.getItem('ExchangeListTab') != '' && localStorage.getItem('ExchangeListTab') != undefined) {
        exchangetab = localStorage.getItem('ExchangeListTab');
        localStorage.removeItem('ExchangeListTab');
      }
      this.router.navigate(['/1031-exchanges'], { queryParams: { activetab: exchangetab } });
    }
  }

  editUser() {
    this.router.navigate(['/registered-user-edit'], { queryParams: { principal: this.principalGuid.toString(), PrevPage: this.prevPage } });
  }

  showProperty(propertyGuid: any) {
    this.router.navigate(['/viewproperty'], { queryParams: { property: propertyGuid } });
  }

  grantOrReject1031Access() {
    this.accessModel.Is1031EnabledId = (this.userDetailsOutput.Is1031EnabledId == YesNo.Yes) ? YesNo.No : YesNo.Yes;
    this.accessModel.UserId = this.principalGuid;

    this._userManagerService.update1031access(this.accessModel).subscribe(response => {
      if (response) {
        this._toastService.addToast({ title: 'Success', msg: 'You have successfully changed the 1031 access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        this.ngOnInit();
      }
      else {
        this._toastService.addToast({ title: 'Error', msg: 'An error Occurred while changing the 1031 access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
    })
  }

  openGrantAccessModal(template: TemplateRef<any>, classes: any) {
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  viewAuditTrail() {
    if (this.isViewAuditTrail == false) {
      this.isViewAuditTrail = true;
      this.viewOrHideLabel = "Hide";
    }
    else {
      this.isViewAuditTrail = false;
      this.viewOrHideLabel = "View";
    }
  }

  GetPermissionData() {
    if (this.userDetailsOutput.UserRoleId == this.authService.UserRole.ExternalBroker) {
      this.IsBroker = true;
      this.IsPrincipal = false;
      this.IsGuest = false;
      this.hasMyPortfolioAccess = 0;
    }
    else if (this.userDetailsOutput.UserRoleId == this.authService.UserRole.GuestUser) {
      this.IsBroker = false;
      this.IsGuest = true;
      this.IsPrincipal = false;
      this.hasMyPortfolioAccess = 0;
    }
    else {
      this.IsBroker = false;
      this.IsGuest = false;
      this.IsPrincipal = true;
      this.hasMyPortfolioAccess = 1;
      if ((this.authService.Admin() || this.authService.SuperAdmin()) && this.userDetailsOutput.Is1031User) {
        this.get1031ExchangesDetails(this.userDetailsOutput.Id);
        this.show1031Exchanges = true;
      }
      let myPortfolioRequestaccess = '';
      if (this.userDetailsOutput.IsMyPortfolioRequested && !this.userDetailsOutput.IsMyPortfolioEnabled) {
        myPortfolioRequestaccess = 'My Portfolio Access';
        this.userRequestedMyPortfolio = true;
      }
      if (this.userDetailsOutput.IsAvailablePropertyRequested && !this.userDetailsOutput.IsAvailablePropertyAccessEnabled) {
        myPortfolioRequestaccess = myPortfolioRequestaccess == '' ? 'Available Property Access' : (myPortfolioRequestaccess + ', Available Property Access');
        this.userRequestedMyPortfolio = true;
      }
      if (this.userDetailsOutput.IsOffMarketPropertyRequested && !this.userDetailsOutput.IsOffMarketPropertyAccessEnabled) {
        myPortfolioRequestaccess = myPortfolioRequestaccess == '' ? 'Off-Market Property Access' : (myPortfolioRequestaccess + ', Off-Market Property Access');
        this.userRequestedMyPortfolio = true;
      }
      if (myPortfolioRequestaccess != '') {
        this.myPortfolioRequestText = 'User has Requested ' + myPortfolioRequestaccess;
      }
    }
  }


  get1031ExchangesDetails(userId: number) {
    this.propertyListing.GetPrincipal1031ExchangeDetails(userId).subscribe(response => {
      this.exchangeList = response;
    });
  }

  getProspectsDetails(userId: number) {
    this.propertyListing.GetProspectsDetails(userId).subscribe(response => {
      this.prosepctsList = response;
    });
  }

  viewDetail(exguid: any, type: string) {
    if (type == 'prospect') {
      this.router.navigate(['/viewproperty/' + exguid], { queryParams: { prevroute: 'External Users', link: this.router.url } });
    }
    else if (type == '1031Dasboard') {
      this.router.navigate(['/dashboard-1031/' + exguid], { queryParams: { activeTab: '1', prevroute: 'External Users', link: this.router.url } });
    }
  }

  prospectText: string = '';
  grantProspectAccess(template: TemplateRef<any>, classes: any, Id: number, access: number) {
    let accessDetails = {
      Id: Id,
      access: access == 1 ? 0 : 1
    }
    this.prospectText = access == 1 ? 'Disabling prospects tab access for this property will remove the ability for all sellers to see the prospects tab. Proceed with this change?'
      : 'Enabling prospects tab access for this property allows all sellers to see the prospects tab. Proceed with this change?';
    this.ModelAccess = accessDetails;
    this.modalRefProspect = this.modalService.show(template, { class: classes });
  }

  ChangeSellerProspectStatus() {
    if (this.ModelAccess != null && this.ModelAccess.Id != null) {
      let status = this.ModelAccess.access == 1 ? true : false;
      this.Loader.display(true);
      this._dashboardService.saveSellerVisibilityForProspect(this.ModelAccess.Id, status).subscribe(res => {
        if (res) {
          this._toastService.addToast({ title: 'Success', msg: ('You have successfully changed the prospect access status'), timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          this.getProspectsDetails(this.userDetailsOutput.Id);
          this.Loader.display(false);
        }
        else {
          this.getProspectsDetails(this.userDetailsOutput.Id);
          this.Loader.display(false);
        }
      })
    }
  }
  Change1031Dashboard(Id: number, Status: any) {
    if (Id != null && Id != null) {
      let status = Status == false ? true : false;
      this.Loader.display(true);
      this._userManagerService.Change1031DashboardAccess(this.userDetailsOutput.UserGuid, status, Id).subscribe(response => {
        if (response) {
          this._toastService.addToast({ title: 'Success', msg: 'You have successfully changed the 1031 dashboard access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          this.get1031ExchangesDetails(this.userDetailsOutput.Id);
          this.Loader.display(false);
        }
        else {
          this._toastService.addToast({ title: 'Error', msg: 'An error Occurred while changing the 1031 dashboard access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
          this.Loader.display(false);
        }
      });
    }
  }

  grantSellerDashboardAccess() {
    if (this.userDetailsOutput.Id != null && this.userDetailsOutput.Id > 0) {
      let status = this.userDetailsOutput.IsSellerDashboardEnabled ? false : true;
      this._userManagerService.ChangeSellerDashboardAccess(this.userDetailsOutput.UserGuid, status).subscribe(response => {
        if (response) {
          this.userDetailsOutput.IsSellerDashboardEnabled = status;
          this._toastService.addToast({ title: 'Success', msg: 'You have successfully changed the seller dashboard access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        }
        else {
          this._toastService.addToast({ title: 'Error', msg: 'An error Occurred while changing the seller dashboard access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        }
      });
    }
    else {
      this.userDetailsOutput.IsSellerDashboardEnabled = this.userDetailsOutput.IsSellerDashboardEnabled ? false : true;
    }
  }

  ChangeAccessStatus(type: number) {
    if (type === 1) {
      this.userDetailsOutput.IsAvailablePropertyAccessEnabled = this.userDetailsOutput.IsAvailablePropertyAccessEnabled ? false : true;
      if (this.userDetailsOutput.Id != null && this.userDetailsOutput.Id > 0) {
        this.grantMyPortfolioDashboardAccess(type, this.userDetailsOutput.IsAvailablePropertyAccessEnabled);
      }
    }
    else if (type === 2) {
      this.userDetailsOutput.IsOffMarketPropertyAccessEnabled = this.userDetailsOutput.IsOffMarketPropertyAccessEnabled ? false : true;
      if (this.userDetailsOutput.Id != null && this.userDetailsOutput.Id > 0) {
        this.grantMyPortfolioDashboardAccess(type, this.userDetailsOutput.IsOffMarketPropertyAccessEnabled);
      }
    }
    else if (type === 3) {
      this.userDetailsOutput.IsMyPortfolioEnabled = this.userDetailsOutput.IsMyPortfolioEnabled ? false : true;
      if (this.userDetailsOutput.Id != null && this.userDetailsOutput.Id > 0) {
        this.grantMyPortfolioDashboardAccess(type, this.userDetailsOutput.IsMyPortfolioEnabled);
      }
    }
  }

  grantMyPortfolioDashboardAccess(type: number, status: boolean) {
    let source = type == 1 ? 'AvailableProperties' : type == 2 ? 'OffMarket' : 'MyPortfolio';
    this._userManagerService.ChangeMyPortfolioAccess(this.userDetailsOutput.UserGuid, source, status).subscribe(response => {
      if (response) {
        let message = type == 1 ? 'Available Properties' : type == 2 ? 'Off Market Properties' : 'My Portfolio';
        this._toastService.addToast({ title: 'Success', msg: ('You have successfully changed the ' + message + ' access status'), timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        this.getMessageContent();
      }
      else {
        let message = type == 1 ? 'Available Properties' : type == 2 ? 'Off Market Properties' : 'My Portfolio';
        this._toastService.addToast({ title: 'Error', msg: ('An error Occurred while changing the ' + message + ' access status'), timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
    });
  }
  getMessageContent() {
    let myPortfolioRequestaccess = '';
    this.userRequestedMyPortfolio = false;
    if (this.userDetailsOutput.IsMyPortfolioRequested && !this.userDetailsOutput.IsMyPortfolioEnabled) {
      myPortfolioRequestaccess = 'My Portfolio Access';
      this.userRequestedMyPortfolio = true;
    }
    if (this.userDetailsOutput.IsAvailablePropertyRequested && !this.userDetailsOutput.IsAvailablePropertyAccessEnabled) {
      myPortfolioRequestaccess = myPortfolioRequestaccess == '' ? 'Available Property Access' : (myPortfolioRequestaccess + ', Available Property Access');
      this.userRequestedMyPortfolio = true;
    }
    if (this.userDetailsOutput.IsOffMarketPropertyRequested && !this.userDetailsOutput.IsOffMarketPropertyAccessEnabled) {
      myPortfolioRequestaccess = myPortfolioRequestaccess == '' ? 'Off-Market Property Access' : (myPortfolioRequestaccess + ', Off-Market Property Access');
      this.userRequestedMyPortfolio = true;
    }
    if (myPortfolioRequestaccess != '') {
      this.myPortfolioRequestText = 'User has Requested ' + myPortfolioRequestaccess;
    }
  }

  onRedirection(type: string) {
    if (type == 'MyPortfolio') {
      this.router.navigate(['/market-snapshot'], { queryParams: { UserGuid: this.userDetailsOutput.UserGuid.toString(), opentab: '1', FromUrl: this.router.url } })
    }
    else if (type == 'Seller') {

    }
  }
}
